import React from 'react'
import styled from 'styled-components'
import { Icon } from 'app-v2/shared/features/icon'
import { colors } from 'shared/assets/styles'
import { COLOR } from '../../../app-v2/design-tokens'
import { restaurantServices } from 'shared/utils'

const { text } = colors
const { DELIVEROO, UBEREATS } = restaurantServices

type Props = {
    services: Array<string>,
    className?: string,
    color?: string
}

const ServicesList = (props: Props) => {
    const { services, color = text } = props
    let deliveryRepeat = false

    return (
        <Container>
            {services &&
                services.map((service, index) => {
                    const isDelivery =
                        service === DELIVEROO || service === UBEREATS

                    /*Display only one delivery icon for all delivery services*/
                    if (!isDelivery || !deliveryRepeat) {
                        if (isDelivery && !deliveryRepeat) {
                            deliveryRepeat = true
                        }
                        return (
                            <ServiceIcon key={index}>
                                <Icon code={service} color={COLOR.PRIMARY} />
                            </ServiceIcon>
                        )
                    } else return null
                })}
        </Container>
    )
}

const Container = styled.div`
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
`

const ServiceIcon = styled.div`
    margin-right: 8px;
    margin-bottom: 5px;
    font-size: 0;
    display: inline;
`

export { ServicesList }
